const supplementVariants = {
    "tusk-mind-keeper": "mind-keeper",
    "tusk-dream-patrol": "dream-patrol",
    "tusk-womens-formula": "womens-formula",
    "tusk-mens-formula": "mens-formula",
};

const productInfo = {
    "mind-keeper": {
        "productTrait": "Longevity & Healthspan",
        "capsuleCount": "60 CT.",
        "latinTitle": "Memoria longa",
        "dosage": "2 daily",
        "donationAmount": "$9.80",
        "donationDetails": "Funds crucial GPS tracking collars allowing researches to safely guide and protect the elephant matriarchs and their herds."
    },
    "dream-patrol": {
        "productTrait": "Rest & Recovery",
        "capsuleCount": "90 CT.",
        "latinTitle": "Somnus profundus",
        "dosage": "3 Nightly Before Bed",
        "donationAmount": "$6.80",
        "donationDetails": "Provides warm fleece blankets and cozy bedding to keep orphaned calves feeling safe and secure through the night.",
    },
    "womens-formula": {
        "productTrait": "Hormonal Balance & Mood",
        "capsuleCount": "90 CT.",
        "latinTitle": "Vitalitas mulierum",
        "dosage": "3 daily",
        "donationAmount": "$8.80",
        "donationDetails": "Supports the dedicated, nurturing keepers who act as surrogate mothers, providing round-the-clock love to orphaned calves."
    },
    "mens-formula": {
        "productTrait": "Testosterone, Power & Vitality",
        "capsuleCount": "180 CT.",
        "latinTitle": "Vigor virilis",
        "dosage": "6 daily",
        "donationAmount": "$11.80",
        "donationDetails": "Equips the brave anti-poaching rangers and aerial survelillance teams who vigilantly protect these gentle giants from harm."
    },
};

const currentUrl = window.location.href;

Object.entries(supplementVariants).forEach(([slug, sku]) => {
    if (currentUrl.includes(`products/${slug}`)) {

        document.querySelector(".product-gallery-card.dt-fcard").classList.add(sku);

        let cardInfoHtml =
            `<div class="dt-fcard-info">
            <p>
                <strong>Take </strong>
                <span>${productInfo[sku].dosage}</span>
            </p>
            <p>
                <strong>Form </strong>
                <span>Capsule</span>
            </p>

            <p>
                <strong>Made </strong>
                <span>Long Island, NY</span>
            </p>
            <p>
                <strong>Formulated </strong>
                <span>Philadelphia, PA</span>
            </p>
        </div>
        <div class="dt-fcard-info">
            <p>
                <strong>Donation per Purchase </strong>
                <span>${productInfo[sku].donationAmount}</span>
            </p>
            <p>
                <strong>Your Contribution</strong>
                <span>${productInfo[sku].donationDetails}</span>
            </p>
        </div>`;

        document.querySelector(".dt-fcard-desc").insertAdjacentHTML("afterend", cardInfoHtml);
        document.querySelector(".dt-fcard-content .scent").textContent = productInfo[sku].productTrait;
        document.querySelector(".dt-fcard-content .weight").textContent = productInfo[sku].capsuleCount;
        document.querySelector(".dt-fcard-content .subhead").textContent = productInfo[sku].latinTitle;
    }
});